import { Box, Typography } from "@mui/material";
import FooterNav from "../FooterNav";
import {useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Recordlist from "./Component/Recordlist";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import axiosInstance from "../../AxiosBaseApi";
import Loader from "../Loader";

const Rechargerecord = () => {
  const navigate = useNavigate();

  const [data, SetData] = useState("");
  const [loading, setLoading] = useState(true);

  // console.log(data)
  const getUserData = async (uid) => {
    try {
      const response = await axiosInstance
        .get(`/bet.php?action=rechargerecord&user=${uid}&page1=1`)

        .then((res) => {
          if (res.status === 200) {
            SetData(res.data);
            setLoading(false);
          } else {
            alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      navigate("/login");
    } else {
      getUserData(token);
    }
  }, []);
  
  return (
    <>
      <div style={{ width: "100%", }}>
        <Box
          sx={{
            display: "flex",
            padding: 1,
            justifyContent: "space-between",
            alignItems: "center",
            background: "#3d3b6f",
          }}
        >
          <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon
              fontSize="medium"
              style={{
                // width: "60px",
                color: "#fff",
                border: "1px solid #f2f3f5",
                borderRadius: 50,
              }}
            />
          </Box>
          <Typography variant="subtitle2" color="#fff">
            Recharge Record
          </Typography>
          <Box> </Box>
        </Box>

        {loading ? (
        <Loader /> // Show the loader when loading is true
      ) : (
        <Recordlist
          data={data}
          text="Deposit"
          bgcolor="#34be8a"
           type="Recharge"
            by="By"
            no="UTR No."
        />)}
        {/* <Box style={{ marginTop: "60px" }}>
          <FooterNav />
        </Box> */}
      </div>
    </>
  );
};
export default Rechargerecord;
